import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointSuitabilityData, type EnrollmentJointSuitabilitySubmitOutput } from '../../../../models'

export const getEnrollmentJointSuitabilityDataMock: EnrollmentJointSuitabilityData = {
  isError: false,
  errors: [],
  activePerson: {
    applicationId: 'test-application-id-123',
    progress: 80,
    path: '/enrollment/joint/bd-shareholder',
    isBrokerDealerEmployer: true,
    isDirectorPolicyMaker: true,
    isPoliticallyExposedPerson: true,
    affiliatedPoliticalOrganizations: ['Democratic Party', 'Environmental Committee'],
    hasPoliticallyExposedImmediateFamilyMembers: true,
    politicallyExposedImmediateFamilyMembers: ['City Council Member', 'State Representative'],
    name: {
      firstName: 'Jonathan',
      lastName: 'Smith',
    },
  },
}

export const submitEnrollmentJointSuitabilityDataMock: EnrollmentJointSuitabilitySubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/confirm-information',
  },
}

export const mockGetEnrollmentJointSuitabilityData = graphql.mutation('getEnrollmentJointSuitabilityData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointSuitabilityDataMock } })
})

export const mockSubmitEnrollmentJointSuitabilityData = graphql.mutation('submitEnrollmentJointSuitabilityData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointSuitabilityDataMock } })
})

export const mockEnrollmentJointSuitability = [
  mockGetEnrollmentJointSuitabilityData,
  mockSubmitEnrollmentJointSuitabilityData,
]
